import React from "react";
import { Env, getAdminApiUrl, Spinner } from "../../shared";
import { useDeals, Deal } from "../../deals/api/useDeals";

export function RecentDealsList({
  env, onPick,
}: {
  env: Env;
  onPick: (deal: Deal) => void;
}) {
  const { deals, loading } = useDeals({ apiUrl: getAdminApiUrl(env), page: 0, limit: 10 });

  return (
    <div className="mt-6">
      <p className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider mb-2">Reuse · recent deals</p>
      {loading && <div className="py-3 flex justify-center"><Spinner size="sm" /></div>}
      {!loading && deals.length === 0 && <p className="text-xs text-gray-600">No recent deals.</p>}
      <div className="space-y-1">
        {deals.map(d => (
          <button
            key={d.id}
            type="button"
            onClick={() => onPick(d)}
            title="Prefill a new deal from this one"
            className="w-full text-left px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg hover:border-violet-500 transition-all"
          >
            <p className="text-xs font-medium text-gray-200 truncate">⟳ {d.title}</p>
            <p className="text-[11px] text-gray-500 truncate">{d.business_name}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
